<template>
    <Card>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-3 mb-2">
          <CustomInput type="select" :select-options="status_options"
                       placeholder="وضعیت را انتخاب کنید"
                       label="انتخاب وضعیت" input_style="twoLine"
                       select-label="title" v-model="filters.status"
          ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-2">
          <CustomInput type="select" :select-options="guilds"
                       placeholder="صنف را انتخاب کنید"
                       label="انتخاب صنف" input_style="twoLine"
                       select-label="title" v-model="filters.guild"
          ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-2">
          <CustomInput type="date"
                       placeholder="بازه ثبت نام از"
                       label="بازه ثبت نام از" input_style="twoLine" v-model="filters.s_date"
          ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-2">
          <CustomInput type="date"
                       placeholder="بازه ثبت نام تا"
                       label="بازه ثبت نام تا" input_style="twoLine" v-model="filters.e_date"
          ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-2">
          <CustomInput type="select"
                       placeholder="انتخاب استان"
                       label="انتخاب استان" input_style="twoLine"
                       v-model="state"
                       :not-select-append-to-body="(!!user_id)"
                       name="state_id" select-label="title"
                       reduce_select="_id" :select-options="states"
          ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-2">
          <CustomInput type="select"
                       placeholder="انتخاب شهر"
                       label="انتخاب شهر" input_style="twoLine" v-model="city"
                       select-label="title" reduce_select="_id"
                       :select-options="cities"
                       name="city_id"
          ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-2">
          <CustomInput
              not-select-append-to-body="(!!user_id)" input_style="twoLine" placeholder="معرف را انتخاب کنید" label="انتخاب معرف" select-label="title"
              :select-options="ref_users_option"
              :fetch-options="getAllUsersForSelect"
              v-model="filters.ref_user"
              reduce_select="_id" type="select"
          ></CustomInput>
        </div>
      </div>
      <LocalDataTable :init-document="is_mounted" :functions="functions" :columns="columns" :ajax-link="ajaxLink"></LocalDataTable>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
import CustomInput from "@/components/CustomInput";
import Swal from "sweetalert2";
import {AppApi} from "@/api/AppApi";
import {makeCode, showSystemNoti} from "@/shared/helper";
import {ProductApi} from "@/api/ProductApi";
let mounted = false;
export default {
  name: "UserList",
  components: {CustomInput, LocalDataTable, Card, MasterLayout},
  data(){
    return{
      filters : {status : {title : 'همه',value : 'all'}},
      guilds : [],
      is_mounted : mounted,
      functions:[
        {name: 'delFunc',method : this.delFunc},
        {name: 'showReferralUsers',method : this.showReferralUsers},
      ],
      ajaxLink : 'admin/user/list',
      columns : [{title : 'عنوان'},{title : 'نوع کاربر'},
        {title : 'تاریخ ثبت'},
        {title : 'کد معرف'},
        {title : 'معرف'},
        {title : 'فعالیت',sortable : false}
      ,{title :'شماره تلفن'},
        {title : 'صنف'},{title : 'وضعیت'},{title : '<i class="far fa-cogs"></i>'},],
      status_options : [
          {title : 'همه',value : 'all'},
          {title : 'درانتظار تایید',value : 'waiting'},
          {title : 'تایید شده',value : 'confirmed'},
          {title : 'رد شده',value : 'denied'},
          {title : 'ثبت نام ناقص',value : 'not_complete'},
          ],
      ref_users_option : [],
      states : [],
      cities : [],
      state : null,
      city : null,
    }
  },
  mounted()
  {
    this.setPageTitle('لیست کاربران');
    this.setShowHead(true);
    this.initPage();
    AppApi.getStates().then(result=>{
      this.states = result;
    });
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    changeListAjax()
    {
      let ajaxLink = 'admin/user/list?t=1';
      if (this.filters.status)
      {
        ajaxLink += '&status='+this.filters.status.value;
      }
      if (this.filters.s_date)
      {
        ajaxLink += '&s_date='+this.filters.s_date;
      }
      if (this.filters.e_date)
      {
        ajaxLink += '&e_date='+this.filters.e_date;
      }
      if (this.filters.guild)
      {
        ajaxLink += '&guild_id='+this.filters.guild._id;
      }
      if (this.filters.ref_user)
      {
        ajaxLink += '&ref_user_id='+this.filters.ref_user._id;
      }
      if (this.state)
      {
        ajaxLink += '&state_id='+this.state._id;
      }
      if (this.city)
      {
        ajaxLink += '&city_id='+this.city._id;
      }
      this.ajaxLink = ajaxLink;
    },
    async delFunc(id,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به کاربر حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deleteUser(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    },
    async initPage()
    {
      await AppApi.getGuildsForSelect().then(result=>{
        if (result.ok)
          this.guilds = result.guilds;
      })
    },
    async getAllUsersForSelect(search,loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getAllUsersForSelect(search);
        if (data.ok)
        {
          this.ref_users_option = data.users;
        }
        else
          this.ref_users_option = [];
      }
      loading(false);
    },
    getCitiesByStateId()
    {
      if (this.state)
      {
        AppApi.getCitiesByStateId(this.state._id).then(result =>
        {
          this.cities = result;
        });
      }
      else
          this.cities = [];
      this.city = null;
    }
    // async showReferralUsers()
    // {
    //   alert('ok');
    // }
  },
  watch:{
    filters:{
      handler()
      {
        this.changeListAjax();
      },
      deep : true,
      immediate: true
    },
    state : {
      handler()
      {
        this.getCitiesByStateId();
        this.changeListAjax();
      },
      deep : true,
      immediate: true
    },
    city : {
      handler()
      {
        this.changeListAjax();
      },
      deep : true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>